export const NavigationConfig: NavigationConfig = {
    layout: {
        style: 'vertical-layout-1',
        width: 'fullwidth',
        navbar: {
            background: 'background',
            folded: false,
            hidden: false,
            position: 'left',
            variant: 'vertical-style-1',
        },
        toolbar: {
            background: 'background',
            hidden: false,
            position: 'below-static',
        },
        footer: {
            background: 'mat-white-500-bg',
            hidden: false,
            position: 'below-fixed',
        },
        sidepanel: {
            hidden: false,
            position: 'right',
        },
    },
    customScrollbars: true,
};

export interface NavigationConfig {
    layout: {
        style: string;
        width: 'fullwidth' | 'boxed';
        navbar: {
            background: string;
            hidden: boolean;
            folded: boolean;
            position: 'left' | 'right' | 'top';
            variant: string;
        };
        toolbar: {
            background: string;
            hidden: boolean;
            position: 'above' | 'above-static' | 'above-fixed' | 'below' | 'below-static' | 'below-fixed';
        };
        footer: {
            background: string;
            hidden: boolean;
            position: 'above' | 'above-static' | 'above-fixed' | 'below' | 'below-static' | 'below-fixed';
        };
        sidepanel: {
            hidden: boolean;
            position: 'left' | 'right';
        };
    };
    customScrollbars: boolean;
}
